import { render, staticRenderFns } from "./popupalert.vue?vue&type=template&id=4de48068&scoped=true&"
import script from "./popupalert.vue?vue&type=script&lang=js&"
export * from "./popupalert.vue?vue&type=script&lang=js&"
import style0 from "./popupalert.vue?vue&type=style&index=0&id=4de48068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de48068",
  null
  
)

export default component.exports